export default "__VITE_ASSET__AxO_XDtk__"